import { Link } from 'react-router-dom';

export default function Footer() {
  const quickLinks = [
    { label: 'Home', href: '/' },
    { label: 'Pharmacy Services', href: '/pharmacy-services' },
    { label: 'Addiction Services', href: '/addiction-services' },
    { label: 'What Is Addiction?', href: '/what-is-addiction' },
    { label: 'Are You Addicted?', href: '/are-you-addicted' },
    { label: 'Drug Use Information', href: '/drug-use' },
    { label: 'Location & Hours', href: '/location' },
    { label: 'Privacy Policy', href: '/privacy' },
  ];

  const serviceLinks = [
    { label: 'Addiction Treatment Programs', href: '/addiction-services' },
    { label: 'Methadone Treatment (MMT)', href: '/methadone-treatment' },
    { label: 'Suboxone Treatment (OAMT)', href: '/suboxone-treatment' },
    { label: 'Naloxone Take-Home Kits', href: '/naloxone-kits' },
    { label: 'Prescription Dispensing', href: '/pharmacy-services' },
    { label: 'MAT – Medication Assisted Treatment', href: '/pharmacy-services' },
    { label: 'Minor Ailment Prescribing', href: '/pharmacy-services' },
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-12 sm:pt-16 pb-6 sm:pb-8 w-full overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-8 sm:mb-12">

          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4 sm:mb-6">
              <img
                src="https://static.readdy.ai/image/621fe86c950ded9745dd2c19cd7c5595/c0b5a15a2b815315bfd2ccbd2c453721.png"
                alt="Thornhill Drug-Mart pharmacy logo"
                className="w-12 h-12 object-contain flex-shrink-0"
              />
              <div>
                <strong className="block text-lg sm:text-xl font-bold">Thornhill Drug-Mart</strong>
                <span className="text-xs sm:text-sm text-gray-400">TSCP Partner</span>
              </div>
            </div>
            <p className="text-sm sm:text-base text-gray-400 leading-relaxed mb-4 sm:mb-6">
              Providing compassionate addiction treatment and comprehensive pharmacy services to the Greater Toronto Area.
            </p>
            <div className="flex space-x-3 sm:space-x-4" aria-label="Social media links">
              <a href="#" aria-label="Thornhill Drug-Mart on Facebook" rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 bg-gray-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer flex-shrink-0">
                <i className="ri-facebook-fill text-base sm:text-lg" aria-hidden="true"></i>
              </a>
              <a href="#" aria-label="Thornhill Drug-Mart on Twitter" rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 bg-gray-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer flex-shrink-0">
                <i className="ri-twitter-fill text-base sm:text-lg" aria-hidden="true"></i>
              </a>
              <a href="#" aria-label="Thornhill Drug-Mart on Instagram" rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 bg-gray-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer flex-shrink-0">
                <i className="ri-instagram-line text-base sm:text-lg" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <nav aria-label="Quick links navigation">
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Quick Links</h4>
            <ul className="space-y-2 sm:space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm sm:text-base text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Services */}
          <nav aria-label="Services navigation">
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Our Services</h4>
            <ul className="space-y-2 sm:space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm sm:text-base text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Contact Info */}
          <address className="not-italic">
            <h4 className="text-base sm:text-lg font-bold mb-4 sm:mb-6">Contact Info</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-teal-400 text-lg sm:text-xl mt-1 flex-shrink-0" aria-hidden="true"></i>
                <a href="https://maps.google.com/?q=8108+Yonge+St+Unit+3-4+Thornhill+ON+L4J+1W4"
                  target="_blank" rel="noopener noreferrer"
                  className="text-sm sm:text-base text-gray-400 hover:text-teal-400 transition-colors">
                  8108 Yonge St Unit 3-4<br />Thornhill, ON L4J 1W4
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <i className="ri-phone-line text-teal-400 text-lg sm:text-xl flex-shrink-0" aria-hidden="true"></i>
                <a href="tel:+19057099985"
                  className="text-sm sm:text-base text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  (905) 709-9985
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-teal-400 text-lg sm:text-xl mt-1 flex-shrink-0" aria-hidden="true"></i>
                <a href="mailto:info@thornhilltreatment.com"
                  className="text-sm sm:text-base text-gray-400 hover:text-teal-400 transition-colors cursor-pointer break-all">
                  info@thornhilltreatment.com
                </a>
              </li>
            </ul>
          </address>

        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-700 pt-6 sm:pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-3 md:space-y-0">
            <p className="text-gray-400 text-xs sm:text-sm text-center md:text-left">
              &copy; {new Date().getFullYear()} Thornhill Drug-Mart. All rights reserved.{' '}
              Partner of <abbr title="Toronto Safe Clinics and Pharmacies">TSCP</abbr>.
            </p>
            <a href="https://cpxs.ca" target="_blank" rel="noopener noreferrer"
              className="text-gray-400 hover:text-teal-400 text-xs sm:text-sm transition-colors cursor-pointer whitespace-nowrap">
              Powered by CipherX Solutions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
